<template>
  <div>
    <v-dialog max-width="950px" v-model="dialog">
      <template v-slot:activator="{ on }">
        <v-btn
          outlined
          large
          v-on="on"
          color="red darken-4"
          class="white font-weight-bold"
        >
          Nueva obra
        </v-btn>
      </template>

      <v-card>
        <v-card-title>
          <h2 class="title">REGISTRAR NUEVA OBRA</h2>
        </v-card-title>

        <v-card-text>
          <template>
            <v-row align="center">
              <v-expansion-panels
                accordion
                focusable
                flat
                hover
                v-model="panel"
              >
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <v-row align="center">
                      <v-icon v-if="!form_obra_valid" left class="black--text"
                        >edith</v-icon
                      >
                      <v-icon v-else left class="green--text"
                        >check_circle</v-icon
                      >OBRA
                    </v-row>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row justify="center">
                      <v-card max-width="500">
                        <h1 class="subtitle-2 text-center">
                          IDENTIFICACIÓN DE LA OBRA
                        </h1>
                        <v-card-text>
                          <p>
                            En esta seccion usted esta registrando la obra,
                            declare el nombre original y los nombres
                            alternativos y/o traducidos a otros idiomas
                          </p>
                          <v-form ref="form_obra" v-model="form_obra_valid">
                            <v-text-field
                              label="Nombre orignal de la obra"
                              :rules="[rules.required]"
                              v-model="solicitud.obraNombreOriginal"
                              outlined
                            ></v-text-field>
                            <v-text-field
                              label="Nombre altenativo 1"
                              v-model="solicitud.obraNombreAlternativo1"
                              dense
                            ></v-text-field>
                            <v-text-field
                              label="Nombre altenativo 2"
                              v-model="solicitud.obraNombreAlternativo2"
                              dense
                            ></v-text-field>
                            <v-text-field
                              label="Nombre altenativo 3"
                              v-model="solicitud.obraNombreAlternativo3"
                              dense
                            ></v-text-field>
                          </v-form>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            outlined
                            small
                            color="red"
                            :disabled="!form_obra_valid"
                            @click="panel++"
                            >Siguiente</v-btn
                          >
                          <v-spacer></v-spacer>
                        </v-card-actions>
                      </v-card>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <v-row align="center">
                      <v-icon v-if="!form_dinapi_valid" left class="black--text"
                        >edith</v-icon
                      >
                      <v-icon v-else left class="green--text"
                        >check_circle</v-icon
                      >DINAPI
                    </v-row>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row justify="center">
                      <v-card max-width="500">
                        <h1 class="subtitle-2 text-center">
                          DE LA PROPIEDAD EN DINAPI
                        </h1>
                        <v-card-text>
                          <p>
                            Favor complete con los datos del regsitro o
                            solicitud otorgado por la DINAPI
                          </p>
                          <v-form ref="form_dinapi" v-model="form_dinapi_valid">
                            Tipo de documento
                            <v-divider></v-divider>
                            <v-radio-group
                              v-model="solicitud.dinapiTipoDocumento"
                              row
                              :rules="[rules.required]"
                            >
                              <v-radio
                                label="Registro"
                                value="Registro"
                              ></v-radio>
                              <v-radio
                                label="Solicitud"
                                value="Solicitud"
                              ></v-radio>
                            </v-radio-group>

                            <v-text-field
                              prepend-icon="edit"
                              label="Nro documento musica"
                              :rules="[rules.required]"
                              v-model="solicitud.dinapiNumeroDocumentoMusica"
                            ></v-text-field>

                            <v-col cols="12" sm="12" md="12">
                              <v-dialog
                                ref="dialog"
                                v-model="modal"
                                :return-value.sync="fecha1"
                                persistent
                                width="290px"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    :value="fecha1 | dateFormat"
                                    label="Fecha documento musica"
                                    prepend-icon="event"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  v-model="fecha1"
                                  locale="es"
                                  scrollable
                                >
                                  <v-spacer></v-spacer>
                                  <v-btn
                                    text
                                    color="primary"
                                    @click="modal = false"
                                    >Cancelar</v-btn
                                  >
                                  <v-spacer></v-spacer>

                                  <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.dialog.save(fecha1)"
                                    >SELECCIONAR</v-btn
                                  >
                                  <v-spacer></v-spacer>
                                </v-date-picker>
                              </v-dialog>
                            </v-col>

                            <v-text-field
                              prepend-icon="edit"
                              label="Nro documento letra"
                              v-model="solicitud.dinapiNumeroDocumentoLetra"
                            ></v-text-field>

                            <v-col cols="12" sm="12" md="12">
                              <v-dialog
                                ref="dialog2"
                                v-model="modal2"
                                :return-value.sync="fecha2"
                                persistent
                                width="290px"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    :value="fecha2 | dateFormat"
                                    label="Fecha documento letra"
                                    prepend-icon="event"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  v-model="fecha2"
                                  locale="es"
                                  scrollable
                                >
                                  <v-spacer></v-spacer>
                                  <v-btn
                                    text
                                    color="primary"
                                    @click="modal2 = false"
                                    >Cancelar</v-btn
                                  >
                                  <v-spacer></v-spacer>

                                  <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.dialog2.save(fecha2)"
                                    >SELECCIONAR</v-btn
                                  >
                                  <v-spacer></v-spacer>
                                </v-date-picker>
                              </v-dialog>
                            </v-col>
                          </v-form>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            outlined
                            small
                            color="red"
                            :disabled="!form_dinapi_valid"
                            @click="panel++"
                            >Siguiente</v-btn
                          >
                          <v-spacer></v-spacer>
                        </v-card-actions>
                      </v-card>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <v-row align="center">
                      <v-icon
                        v-if="!form_grabaciones_valid"
                        left
                        class="black--text"
                        >edith</v-icon
                      >
                      <v-icon v-else left class="green--text"
                        >check_circle</v-icon
                      >GRABACIONES
                    </v-row>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row justify="center">
                      <v-card max-width="500">
                        <h1 class="subtitle-2 text-center">GRABACIONES</h1>
                        <v-card-text>
                          <p>Favor complete con los datos solicitados</p>

                          <v-form
                            ref="form_grabaciones"
                            v-model="form_grabaciones_valid"
                          >
                            <v-text-field
                              label="Compañia"
                              :rules="[rules.required]"
                              v-model="solicitud.grabacionCompania"
                            ></v-text-field>
                            <v-text-field
                              label="Interprete"
                              :rules="[rules.required]"
                              v-model="solicitud.grabacionInterprete"
                            ></v-text-field>
                          </v-form>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            outlined
                            small
                            color="red"
                            :disabled="!form_grabaciones_valid"
                            @click="panel++"
                            >Siguiente</v-btn
                          >
                          <v-spacer></v-spacer>
                        </v-card-actions>
                      </v-card>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <v-row align="center">
                      <v-icon
                        v-if="solicitud.participaciones.length == 0"
                        left
                        class="black--text"
                        >edith</v-icon
                      >
                      <v-icon v-else left class="green--text"
                        >check_circle</v-icon
                      >PARTICIPACIONES
                    </v-row>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row justify="center">
                      <v-col cols="12">
                        <v-card max-width="900">
                          <h1 class="subtitle-2 text-center">
                            PARTICIPACIONES
                          </h1>
                          <v-card-text>
                            <p class="mx-2">
                              Por favor declare el porcentaje de su propia
                              autoria. Tambien incluya a los demas autores y
                              potcentajes si corresponde al caso
                            </p>
                            <v-container fluid>
                              <v-row>
                                <v-col
                                  v-for="par in solicitud.participaciones"
                                  :key="par.id"
                                  cols="sm-4 md-6"
                                >
                                  <v-card width="240px" class="ma-2">
                                    <v-card-text>
                                      <b>Rol:</b>
                                      {{ par.rol }}
                                      <br />
                                      <b>Nombres:</b>
                                      {{ par.nombres }}
                                      <br />
                                      <b>Apellidos:</b>
                                      {{ par.apellidos }}
                                      <br />
                                      <b>% Ejecución:</b>
                                      {{ par.porcentajeEjecucion }}
                                      <br />
                                      <b>% Mecánico:</b>
                                      {{ par.porcentajeMecanico }}
                                      <br />
                                      <b>% Syncro:</b>
                                      {{ par.porcentajeSyncro }}
                                      <br />
                                    </v-card-text>
                                    <v-divider></v-divider>
                                    <v-card-actions>
                                      <v-spacer></v-spacer>
                                      <Participacion
                                        :participacion="par"
                                        icon="edit"
                                        @save="saveParticipacion"
                                      />
                                      <v-spacer></v-spacer>
                                      <v-btn
                                        @click="removeParticipacion(par)"
                                        color="red"
                                        outlined
                                        small
                                      >
                                        <v-icon>remove</v-icon>
                                      </v-btn>
                                      <v-spacer></v-spacer>
                                    </v-card-actions>
                                  </v-card>
                                </v-col>

                                <v-col>
                                  <v-card width="240px" class="ma-2">
                                    <v-container fill-height>
                                      <v-row align="center" justify="center">
                                        <v-col>
                                          <Participacion
                                            @save="saveParticipacion"
                                            icon="add"
                                          />
                                        </v-col>
                                      </v-row>
                                    </v-container>
                                  </v-card>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card-text>
                          <v-divider></v-divider>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              :disabled="solicitud.participaciones.length == 0"
                              outlined
                              small
                              color="red"
                              @click="panel++"
                              >Siguiente</v-btn
                            >
                            <v-spacer></v-spacer>
                          </v-card-actions>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <v-row align="center">
                      <v-icon
                        v-if="solicitud.adjuntos.length == 0"
                        left
                        class="black--text"
                        >edith</v-icon
                      >
                      <v-icon v-else left class="green--text"
                        >check_circle</v-icon
                      >ADJUNTOS
                      <span
                        class="caption mx-5"
                        v-if="solicitud.adjuntos.length > 0"
                      >
                        {{ solicitud.adjuntos.length }} archivo(s)
                        adjuntado(s)</span
                      >
                    </v-row>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row justify="center">
                      <v-col cols="12">
                        <v-card max-width="900">
                          <h1 class="subtitle-2 text-center">
                            ADJUNTOS
                          </h1>

                          <v-card-text>
                            <p>
                              Puedes agregar audios, partituras y otros
                              documentos relacionados a su obra
                            </p>

                            <v-container fluid>
                              <v-row>
                                <v-col
                                  v-for="ad in solicitud.adjuntos"
                                  :key="ad.id"
                                  cols="4"
                                >
                                  <v-card width="240px" class="ma-2">
                                    <v-card-text>
                                      <b>Tipo:</b>
                                      {{ ad.tipo }}
                                    </v-card-text>
                                    <v-divider></v-divider>
                                    <v-card-actions>
                                      <v-spacer></v-spacer>
                                      <v-btn
                                        @click="removeAdjunto(ad)"
                                        color="red"
                                        outlined
                                        small
                                      >
                                        <v-icon>remove</v-icon>
                                      </v-btn>
                                      <v-spacer></v-spacer>
                                    </v-card-actions>
                                  </v-card>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card-text>
                          <v-card-actions>
                            <v-container fluid>
                              <v-row justify="space-around">
                                <v-col>
                                  <UploadFile
                                    @save="saveAudio"
                                    btnLabel="AUDIO"
                                    accept="audio/*"
                                    title="ADJUNTAR AUDIO"
                                  />
                                </v-col>
                                <v-col>
                                  <UploadFile
                                    @save="savePartitura"
                                    btnLabel="PARTITURA"
                                    accept="image/*,.pdf"
                                    title="ADJUNTAR PARTITURA"
                                  />
                                </v-col>
                                <v-col>
                                  <UploadFile
                                    @save="saveOtro"
                                    btnLabel="OTROS"
                                    accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                    title="ADJUNTAR OTROS DOCUMENTOS"
                                  />
                                </v-col>
                              </v-row>
                            </v-container>

                            <v-spacer></v-spacer>
                          </v-card-actions>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-row>
          </template>
        </v-card-text>
        <h1 color="red">{{ errorMessage }}</h1>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="volver">Volver</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            class="white--text darken-4"
            @click="registrar"
            :disabled="!validForm"
            :loading="enviandoSolicitud"
            >Enviar solicitud</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import Participacion from "@/components/obras/Participacion.vue";
import UploadFile from "@/components/obras/UploadFile.vue";
import moment from "moment";

export default {
  data() {
    return {
      enviandoSolicitud: false,
      modal: false,
      modal2: false,
      fecha1: null,
      fecha2: null,
      panel: 0,
      form_obra_valid: false,
      form_dinapi_valid: false,
      form_grabaciones_valid: false,
      form_participaciones_valid: false,
      errorMessage: "",
      value: "",
      rules: {
        required: value => !!value || "Requerido.",
        counter: value => value.length <= 1000 || "Maximo 100 caracteres"
      },
      tipo_documento_dinapi: [
        { text: "Registro", value: "Registro" },
        { text: "Solicitud", value: "Solicitud" }
      ],
      dialog: false,
      solicitud: {
        participaciones: [],
        adjuntos: []
      },
      icon_obra: { icon: "edit", color: "black--text" },
      icon_dinapi: { icon: "edit", color: "black--text" },
      icon_grabaciones: { icon: "edit", color: "black--text" },
      icon_participaciones: { icon: "check_circle", color: "green--text" },
      icon_adjuntos: { icon: "check_circle", color: "green--text" }
    };
  },
  filters: {
    // numberFormat(value) {
    //   if (value) {
    //     return numeral(value).format("#,##0"); // displaying other groupings/separators is possible, look at the docs
    //   }
    // },
    dateFormat(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
      }

      return "";
    }
  },
  methods: {
    registrar() {
      //this.snackbar = true;
      this.errorMessage = "";

      //cambiamos la fecha FUCK v-date-picker

      if (this.fecha1) {
        this.solicitud.dinapiFechaDocumentoMusica = moment(
          this.fecha1
        ).toDate();
      }

      if (this.fecha2) {
        this.solicitud.dinapiFechaDocumentoLetra = moment(this.fecha2).toDate();
      }

      this.enviandoSolicitud = true;
      axios
        .post("/miapa/nuevaSolicitudRegistroObra", this.solicitud)
        .then(res => {
          this.solicitud = { participaciones: [], adjuntos: [] };
          console.log(res);
          this.resetForms();
          this.dialog = false;
          this.enviandoSolicitud = false;
          this.$store.dispatch(
            "showSnack",
            "Solicitud enviada! Pronto recibirá un correo de confirmación"
          );
        })
        .catch(err => {
          console.log(err);
          this.errorMessage = err;
          this.enviandoSolicitud = false;
        });
    },
    volver() {
      this.dialog = false;
    },
    saveParticipacion(data) {
      if (data.old) {
        this.solicitud.participaciones.forEach((element, index) => {
          if (element.id == data.new.id) {
            this.solicitud.participaciones.splice(index, 1, data.new);
            return;
          }
        });
      } else {
        this.solicitud.participaciones.push({ id: Math.random(), ...data.new });
      }
    },
    saveAudio(data) {
      this.solicitud.adjuntos.push({
        id: Math.random(),
        nombre: data,
        tipo: "Audio"
      });
    },
    savePartitura(data) {
      this.solicitud.adjuntos.push({
        id: Math.random(),
        nombre: data,
        tipo: "Partitura"
      });
    },
    saveOtro(data) {
      this.solicitud.adjuntos.push({
        id: Math.random(),
        nombre: data,
        tipo: "Otro"
      });
    },
    removeParticipacion(par) {
      this.solicitud.participaciones = this.solicitud.participaciones.filter(
        p => p.id != par.id
      );
    },
    removeAdjunto(adj) {
      this.solicitud.adjuntos = this.solicitud.adjuntos.filter(
        a => a.id != adj.id
      );
    },
    resetForms() {
      this.solicitud = {
        participaciones: [],
        adjuntos: []
      };
      this.$refs.form_obra.reset();
      this.$refs.form_dinapi.reset();
      this.$refs.form_grabaciones.reset();
      this.panel = 0;
    }
  },
  computed: {
    validForm() {
      return (
        this.form_obra_valid &&
        this.form_dinapi_valid &&
        this.form_grabaciones_valid &&
        this.solicitud.participaciones.length > 0
      );
    }
  },
  components: {
    Participacion,
    UploadFile
  }
};
</script>
